export default function Plot_Plotly() {
  return (
    <div>
      <h1>Plot_Plotly Component</h1>
    </div>
  );
}
